export default "__VITE_ASSET__Bc2rWtUh__"